import { useQuery } from '@apollo/client';
import { usePortalPermissions } from '../../Common/hooks/usePortalPermissions';
import { graphql } from '../../__generated__';

export const GET_CUSTOMER_IHI = graphql(`
  query customerIHI($customerId: String) {
    ihi(customerId: $customerId)
  }
`);

export const useCustomerIHI = (customerId: string) => {
  const { loading: ihiLoading, data: ihiData } = useQuery(GET_CUSTOMER_IHI, {
    variables: { customerId: customerId },
    skip: !customerId,
  });

  return { ihiLoading, ihi: ihiData?.ihi, canViewIHI: true };
};
